import './styles.scss'

export default function AnchorBlock({ items }) {
  return (
    <div className={'dhsv-anchor-block'}>
      {items.length && (
        <div className="anchor-wrapper">
          {items.map(item => (
            // eslint-disable-next-line react/jsx-key
            <a href={item.id} className="anchor-link">
              {item.title}
            </a>
          ))}
        </div>
      )}
    </div>
  )
}
